/* eslint-disable no-param-reassign */
export function slideDown(element) {
  element.style.display = 'block';
  element.style.height = 'auto';
  const height = `${element.offsetHeight}px`;
  element.style.height = '0px';
  setTimeout(() => {
    element.style.height = height;
    // アニメーションが終わった後コンテンツの中の高さが変更しても追従するようにautoに変更
    setTimeout(() => {
      element.style.height = 'auto';
    }, 200);
  }, 0);
}

export function slideUp(element) {
  const height = `${element.offsetHeight}px`;
  element.style.height = height;
  setTimeout(() => {
    element.style.height = '0px';
    // アニメーション中にdisplay: noneに変更するとアニメーションが止まってしまうので終わった後に変更する
    setTimeout(() => {
      element.style.display = 'none';
    }, 200);
  }, 0);
}
